import type { ISchedule, ScheduleEventType } from 'src/api/getSchedules/types';

export type IDisplaySchedule = Omit<ISchedule, 'event_type'> & {
  event_type: ScheduleEventType;
  schedule_ids: string[];
};

export const mapSchedules = (schedules: ISchedule[]): IDisplaySchedule[] => {
  return schedules.map((schedule) => {
    return { ...schedule, schedule_ids: [schedule.schedule_id] };
  });
};
